export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    DateTime: any;
};

export type AbbaTargetExperiment = {
    __typename?: "AbbaTargetExperiment";
    experimentId?: Maybe<Scalars["String"]>;
    population?: Maybe<Scalars["Float"]>;
    startTime?: Maybe<Scalars["DateTime"]>;
    endTime?: Maybe<Scalars["DateTime"]>;
    buckets?: Maybe<Array<Maybe<AbbaTargetExperimentBucket>>>;
    locked?: Maybe<Scalars["Boolean"]>;
};

export type AbbaTargetExperimentBucket = {
    __typename?: "AbbaTargetExperimentBucket";
    bucketId?: Maybe<Scalars["String"]>;
    config?: Maybe<Scalars["String"]>;
};

/** ABBA test variant */
export type AbbaVariant = {
    __typename?: "AbbaVariant";
    id?: Maybe<Scalars["String"]>;
    page_name?: Maybe<Scalars["String"]>;
    variation?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    ab_config_key?: Maybe<Scalars["String"]>;
};

export type AdTargeting = {
    __typename?: "AdTargeting";
    adCode?: Maybe<Scalars["String"]>;
    suid?: Maybe<Scalars["String"]>;
    page?: Maybe<Scalars["String"]>;
    currentResource?: Maybe<Scalars["String"]>;
    ni?: Maybe<Array<Maybe<Scalars["String"]>>>;
    tagr?: Maybe<Array<Maybe<Scalars["String"]>>>;
    kwl?: Maybe<Array<Maybe<Scalars["String"]>>>;
    sites?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Mobile alerts for web display */
export type Alert = {
    __typename?: "alert";
    id?: Maybe<Scalars["String"]>;
    body?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
    image?: Maybe<Scalars["String"]>;
    regions?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type AssetMedia = {
    __typename?: "AssetMedia";
    id?: Maybe<Scalars["String"]>;
    kind?: Maybe<Scalars["String"]>;
    assetType?: Maybe<Scalars["String"]>;
    hedAndDekPosition?: Maybe<Scalars["String"]>;
    caption?: Maybe<Scalars["String"]>;
    credit?: Maybe<Scalars["String"]>;
};

export type Audio = {
    __typename?: "Audio";
    id?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    description?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
    key?: Maybe<Scalars["String"]>;
    duration?: Maybe<Scalars["String"]>;
    extension?: Maybe<Scalars["String"]>;
    codec?: Maybe<Scalars["String"]>;
    allowedOnWeb?: Maybe<Scalars["Boolean"]>;
    syndicated?: Maybe<Scalars["Boolean"]>;
    publishedAt?: Maybe<Scalars["Int"]>;
    rawUrl?: Maybe<Scalars["String"]>;
};

export type Autofill = {
    __typename?: "Autofill";
    type?: Maybe<AutofillType>;
    args?: Maybe<Scalars["String"]>;
};

export enum AutofillType {
    Personalized = "PERSONALIZED",
}

export type AutoSummary = {
    __typename?: "AutoSummary";
    text?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    version?: Maybe<Scalars["String"]>;
};

export type Award = {
    __typename?: "Award";
    awardName?: Maybe<Scalars["String"]>;
    date?: Maybe<Scalars["String"]>;
    text?: Maybe<Scalars["String"]>;
};

export type Awards = {
    __typename?: "Awards";
    awards?: Maybe<Array<Maybe<Award>>>;
    publications?: Maybe<Array<Maybe<Publication>>>;
    numAwards?: Maybe<Scalars["Int"]>;
    numPublications?: Maybe<Scalars["Int"]>;
};

export type Bitrate = {
    __typename?: "Bitrate";
    audio?: Maybe<Scalars["Int"]>;
    video?: Maybe<Scalars["Int"]>;
};

export type BoardMembership = {
    __typename?: "BoardMembership";
    title?: Maybe<Scalars["String"]>;
    tenure?: Maybe<Scalars["String"]>;
    companyName?: Maybe<Scalars["String"]>;
    ticker?: Maybe<Scalars["String"]>;
    webTicker?: Maybe<Scalars["String"]>;
};

export enum Brand {
    View = "VIEW",
    Gadfly = "GADFLY",
    Quicktake = "QUICKTAKE",
    Business = "BUSINESS",
    Politics = "POLITICS",
    Businessweek = "BUSINESSWEEK",
    Markets = "MARKETS",
    Technology = "TECHNOLOGY",
    Pursuits = "PURSUITS",
    Cojp = "COJP",
    Sponsored = "SPONSORED",
    Green = "GREEN",
    Citylab = "CITYLAB",
}

/** Sponsored Campaign Information. */
export type Campaign = {
    __typename?: "Campaign";
    /** Campaign ID */
    id?: Maybe<Scalars["String"]>;
    /** Full campaign title */
    name?: Maybe<Scalars["String"]>;
    /** Date and time that campaign starts */
    startsAt?: Maybe<Scalars["DateTime"]>;
    /** Date and time that campaign ends */
    endsAt?: Maybe<Scalars["DateTime"]>;
    /** Image for advertiser logo */
    logo?: Maybe<Image>;
    /** URL that advertiser logo links to */
    url?: Maybe<Scalars["String"]>;
    /** Advertiser ID */
    advertiserId?: Maybe<Scalars["String"]>;
};

export type Career = {
    __typename?: "Career";
    ticker?: Maybe<Scalars["String"]>;
    organization?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    webTicker?: Maybe<Scalars["String"]>;
    timespan?: Maybe<Scalars["String"]>;
};

export type Chart = {
    __typename?: "Chart";
    id?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    subtitle?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
    theme?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    footnote?: Maybe<Scalars["String"]>;
    source?: Maybe<Scalars["String"]>;
    aspectRatio?: Maybe<Scalars["String"]>;
    html?: Maybe<Scalars["String"]>;
    offRail?: Maybe<Scalars["Boolean"]>;
    /** The system that was used to create this chart. Either toaster, G, or unknown. */
    creator: ChartCreator;
    /** For G charts, this is the terminal function that will display the chart */
    terminalFunction?: Maybe<Scalars["String"]>;
    /** Height of chart when rendered at default body width (usually 740px). */
    renderHeight?: Maybe<Scalars["Int"]>;
    /** Either "image" or "iframe" the API provides a default render format */
    renderFormat: ChartRenderFormat;
    /** Prerendered charts for responsive mobile/widget display */
    responsiveImages?: Maybe<ChartResponsiveImageSet>;
};

export enum ChartCreator {
    Toaster = "TOASTER",
    G = "G",
    Unknown = "UNKNOWN",
}

export enum ChartRenderFormat {
    Image = "IMAGE",
    Iframe = "IFRAME",
}

export type ChartResponsiveImage = {
    __typename?: "ChartResponsiveImage";
    id?: Maybe<Scalars["String"]>;
    height?: Maybe<Scalars["Int"]>;
    width?: Maybe<Scalars["Int"]>;
    canvasWidth?: Maybe<Scalars["Int"]>;
    /** Bpix image URL allowing custom thumbnail sizing */
    url?: Maybe<Scalars["String"]>;
};

export type ChartResponsiveImageSet = {
    __typename?: "ChartResponsiveImageSet";
    widget?: Maybe<ChartResponsiveImage>;
    mobile?: Maybe<ChartResponsiveImage>;
    large?: Maybe<ChartResponsiveImage>;
};

export type Codec = {
    __typename?: "Codec";
    audio?: Maybe<Scalars["String"]>;
    video?: Maybe<Scalars["String"]>;
};

export type Column = {
    __typename?: "Column";
    modules?: Maybe<Array<Maybe<CurationModule>>>;
};

export type ColumnModulesArgs = {
    skipModuleExpansion?: Maybe<Scalars["Boolean"]>;
};

export type Company = {
    __typename?: "Company";
    id?: Maybe<Scalars["String"]>;
    name?: Maybe<Scalars["String"]>;
    longName?: Maybe<Scalars["String"]>;
};

/**
 * The fields id, type, directScore, and derivedScore are passed through. Querying
 * for the name field will incur an additional cost, as a network request will be
 * made to resolve it.
 **/
export type ContentTag = {
    __typename?: "ContentTag";
    id?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    directScore?: Maybe<Scalars["Float"]>;
    derivedScore?: Maybe<Scalars["Float"]>;
    name?: Maybe<Scalars["String"]>;
};

export type ContentTagsFilter = {
    id?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
};

export type ContentTagsSort = {
    order?: Maybe<SortOrder>;
    scoreType?: Maybe<TagScoreType>;
};

export enum ContentType {
    Article = "article",
    Feature = "feature",
    Slideshow = "slideshow",
    Storythread = "storythread",
    ImpactScorecard = "impact_scorecard",
    BreakingNews = "breaking_news",
    NewsletterCampaign = "newsletter_campaign",
    Letter = "letter",
}

export type ContextItem = {
    __typename?: "ContextItem";
    id?: Maybe<Scalars["Int"]>;
    languages?: Maybe<Array<Maybe<Language>>>;
};

export enum Criteria {
    PercentUp = "PERCENT_UP",
    PercentDown = "PERCENT_DOWN",
    Volume = "VOLUME",
}

export type CuratedItem = Story | CuratedLink | Security;

export type CuratedLink = {
    __typename?: "CuratedLink";
    name?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    headline?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    originalType?: Maybe<Scalars["String"]>;
    mainTout?: Maybe<Scalars["String"]>;
    subTout?: Maybe<Scalars["String"]>;
    listId?: Maybe<Scalars["String"]>;
    slideoutTout?: Maybe<Scalars["String"]>;
    summary?: Maybe<Scalars["String"]>;
    zone?: Maybe<Scalars["String"]>;
    zoneLayout?: Maybe<Scalars["String"]>;
    position?: Maybe<Scalars["String"]>;
    site?: Maybe<Scalars["String"]>;
    page?: Maybe<Scalars["String"]>;
    curatedAt?: Maybe<Scalars["DateTime"]>;
    related?: Maybe<RelatedStories>;
    thumbnail?: Maybe<Image>;
};

export type CuratedLinkThumbnailArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
};

export type Curation = {
    __typename?: "Curation";
    id?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    description?: Maybe<Scalars["String"]>;
    /** Page level brand used to apply front-end themes */
    brand?: Maybe<Scalars["String"]>;
    /** The url path as defined in EditDash */
    path?: Maybe<Scalars["String"]>;
    /** Page level theme */
    theme?: Maybe<Scalars["String"]>;
    modules?: Maybe<Array<Maybe<CurationModule>>>;
    module?: Maybe<CurationModule>;
};

export type CurationModulesArgs = {
    id?: Maybe<Scalars["String"]>;
};

export type CurationModuleArgs = {
    id: Scalars["String"];
};

export type CurationModule = {
    __typename?: "CurationModule";
    id?: Maybe<Scalars["String"]>;
    /**
     * This field allows for dynamic attributes. Usage:
     *   modules {
     *     text: variable(id: 'text')
     *     color: variable(id: 'color')
     *   }
     **/
    variable?: Maybe<Scalars["String"]>;
    updatedAt?: Maybe<Scalars["DateTime"]>;
    editorialTitle?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    subtitle?: Maybe<Scalars["String"]>;
    name?: Maybe<Scalars["String"]>;
    autofill?: Maybe<Scalars["Boolean"]>;
    autofillData?: Maybe<Autofill>;
    skipDedup?: Maybe<Scalars["Boolean"]>;
    type?: Maybe<Scalars["String"]>;
    position?: Maybe<Scalars["String"]>;
    grouping?: Maybe<Scalars["String"]>;
    layout?: Maybe<Scalars["String"]>;
    zone?: Maybe<Scalars["String"]>;
    theme?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    variation?: Maybe<Scalars["String"]>;
    facebook_account?: Maybe<Scalars["String"]>;
    twitter_account?: Maybe<Scalars["String"]>;
    youtube_account?: Maybe<Scalars["String"]>;
    instagram_account?: Maybe<Scalars["String"]>;
    linkedin_account?: Maybe<Scalars["String"]>;
    list_id?: Maybe<Scalars["String"]>;
    embedUrl?: Maybe<Scalars["String"]>;
    embedHeight?: Maybe<Scalars["String"]>;
    adType?: Maybe<Scalars["String"]>;
    adPositionIncremented?: Maybe<Scalars["Boolean"]>;
    adPositionIncrement?: Maybe<Scalars["String"]>;
    adSpacing?: Maybe<Scalars["String"]>;
    duplicateOf?: Maybe<Scalars["String"]>;
    pageId?: Maybe<Scalars["String"]>;
    labelUrl?: Maybe<Scalars["String"]>;
    altLabel?: Maybe<Scalars["String"]>;
    altLabelUrl?: Maybe<Scalars["String"]>;
    autoplay?: Maybe<Scalars["Boolean"]>;
    sponsored?: Maybe<Scalars["Boolean"]>;
    streamId?: Maybe<Scalars["String"]>;
    ratePlans?: Maybe<Array<Maybe<RatePlan>>>;
    callToAction?: Maybe<Scalars["String"]>;
    html?: Maybe<Scalars["String"]>;
    image?: Maybe<Image>;
    items?: Maybe<Array<Maybe<CuratedItem>>>;
    stories?: Maybe<Array<Maybe<Story>>>;
    ab_config_key?: Maybe<Scalars["String"]>;
    ab_variants?: Maybe<Array<Maybe<AbbaVariant>>>;
    tracking?: Maybe<Tracking>;
};

export type CurationModuleVariableArgs = {
    id: Scalars["String"];
};

export type DateRange = {
    from?: Maybe<Scalars["DateTime"]>;
    to?: Maybe<Scalars["DateTime"]>;
};

export type DateTimeValue = {
    __typename?: "DateTimeValue";
    dateTime?: Maybe<Scalars["String"]>;
    value?: Maybe<Scalars["Float"]>;
};

export type Education = {
    __typename?: "Education";
    schools?: Maybe<Array<Maybe<School>>>;
};

export type Episode = {
    __typename?: "Episode";
    eventType?: Maybe<Scalars["String"]>;
    showMrcId?: Maybe<Scalars["String"]>;
    encoderGroupId?: Maybe<Scalars["Int"]>;
    episodeNiCode?: Maybe<Array<Maybe<Scalars["String"]>>>;
    episodeTitle?: Maybe<Scalars["String"]>;
    episodeDescription?: Maybe<Scalars["String"]>;
    episodeStartTime?: Maybe<Scalars["DateTime"]>;
    episodeEndTime?: Maybe<Scalars["DateTime"]>;
    enpsGridId?: Maybe<Scalars["String"]>;
    episodeStartTimeLocal?: Maybe<Scalars["DateTime"]>;
    episodeEndTimeLocal?: Maybe<Scalars["DateTime"]>;
    episodeHasArchive?: Maybe<Scalars["Int"]>;
    mrcRegion?: Maybe<Scalars["String"]>;
    episodeMrcId?: Maybe<Scalars["String"]>;
    eventLinkId?: Maybe<Scalars["String"]>;
    thumbnail?: Maybe<Image>;
};

export enum ExchangeMoversDirection {
    Up = "UP",
    Down = "DOWN",
}

export enum ExchangeMoversPeriod {
    Yesterday = "YESTERDAY",
    Today = "TODAY",
    Intraday = "INTRADAY",
    OneMinute = "ONE_MINUTE",
    FiveMinutes = "FIVE_MINUTES",
    FifteenMinutes = "FIFTEEN_MINUTES",
    Hour = "HOUR",
}

export enum ExchangeMoversTableType {
    VolumeChange = "VOLUME_CHANGE",
    PriceChange = "PRICE_CHANGE",
    PricePctChange = "PRICE_PCT_CHANGE",
    TradeValueChange = "TRADE_VALUE_CHANGE",
    VolumeIncrease_1D = "VOLUME_INCREASE_1D",
    VolumeIncrease_5D = "VOLUME_INCREASE_5D",
    VolumeIncrease_20D = "VOLUME_INCREASE_20D",
}

export type FloatRange = {
    min?: Maybe<Scalars["Float"]>;
    max?: Maybe<Scalars["Float"]>;
};

export type FundHolding = {
    __typename?: "FundHolding";
    security?: Maybe<Scalars["String"]>;
    ticker?: Maybe<Scalars["String"]>;
    name?: Maybe<Scalars["String"]>;
    percentNet?: Maybe<Scalars["Float"]>;
    change?: Maybe<Scalars["Float"]>;
    marketValue?: Maybe<Scalars["Float"]>;
    position?: Maybe<Scalars["Float"]>;
    filingDate?: Maybe<Scalars["String"]>;
};

export type Guest = {
    __typename?: "Guest";
    encoderGroupId?: Maybe<Scalars["Int"]>;
    guestSource?: Maybe<Scalars["String"]>;
    eventLinkId?: Maybe<Scalars["String"]>;
    guestName?: Maybe<Scalars["String"]>;
    guestCompanyName?: Maybe<Scalars["String"]>;
    guestCompanyTicker?: Maybe<Scalars["String"]>;
    guestTitle?: Maybe<Scalars["String"]>;
    guestStartTime?: Maybe<Scalars["DateTime"]>;
    guestEndTime?: Maybe<Scalars["DateTime"]>;
    eventStartTime?: Maybe<Scalars["DateTime"]>;
    eventEndTime?: Maybe<Scalars["DateTime"]>;
    guestStartTimeLocal?: Maybe<Scalars["DateTime"]>;
    guestEndTimeLocal?: Maybe<Scalars["DateTime"]>;
    guestUpdateTime?: Maybe<Scalars["DateTime"]>;
    guestUpdateUuid?: Maybe<Scalars["Int"]>;
    interviewTopics?: Maybe<Array<Maybe<Scalars["String"]>>>;
    guestStatusId?: Maybe<Scalars["Int"]>;
    companiesMentioned?: Maybe<Array<Maybe<Scalars["String"]>>>;
    peopleMentioned?: Maybe<Array<Maybe<Scalars["String"]>>>;
    guest?: Maybe<Person>;
    thumbnail?: Maybe<Image>;
};

export enum IdType {
    Bmmr = "BMMR",
    Avmm = "AVMM",
    Ooyala = "OOYALA",
}

export type Iframe = {
    __typename?: "Iframe";
    url?: Maybe<Scalars["String"]>;
    rel?: Maybe<Array<Maybe<Scalars["String"]>>>;
    html?: Maybe<Scalars["String"]>;
    meta?: Maybe<IframeMeta>;
    dimension?: Maybe<IframeDimension>;
};

export type IframeDimension = {
    __typename?: "IframeDimension";
    width?: Maybe<Scalars["Int"]>;
    height?: Maybe<Scalars["Int"]>;
    maxWidth?: Maybe<Scalars["Int"]>;
    minWidth?: Maybe<Scalars["Int"]>;
    maxHeight?: Maybe<Scalars["Int"]>;
    minHeight?: Maybe<Scalars["Int"]>;
    aspectRatio?: Maybe<Scalars["Float"]>;
};

export type IframeMeta = {
    __typename?: "IframeMeta";
    canonical?: Maybe<Scalars["String"]>;
    media?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    description?: Maybe<Scalars["String"]>;
    site?: Maybe<Scalars["String"]>;
    author?: Maybe<Scalars["String"]>;
    author_url?: Maybe<Scalars["String"]>;
};

export type Image = {
    __typename?: "Image";
    /** Constructed alt string for alt text */
    alt?: Maybe<Scalars["String"]>;
    id?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    description?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
    height?: Maybe<Scalars["Int"]>;
    origHeight?: Maybe<Scalars["Int"]>;
    width?: Maybe<Scalars["Int"]>;
    origWidth?: Maybe<Scalars["Int"]>;
    caption?: Maybe<Scalars["String"]>;
    credit?: Maybe<Scalars["String"]>;
    source?: Maybe<Scalars["String"]>;
    treatment?: Maybe<Scalars["String"]>;
    size?: Maybe<Scalars["String"]>;
    publishedAt?: Maybe<Scalars["Int"]>;
    submitAppId?: Maybe<Scalars["String"]>;
    mobile?: Maybe<AssetMedia>;
    desktop?: Maybe<AssetMedia>;
    svgFile?: Maybe<Scalars["String"]>;
    /** OK to syndicate */
    isSyndicationPortal?: Maybe<Scalars["Boolean"]>;
    /** Helps to determine syndicate */
    privilegeValue?: Maybe<Scalars["String"]>;
    /** Provides photographer credits */
    photoCredit?: Maybe<Scalars["String"]>;
    themes?: Maybe<Array<Maybe<Theme>>>;
};

export type IntradayRangeValue = {
    __typename?: "IntradayRangeValue";
    start?: Maybe<Scalars["String"]>;
    end?: Maybe<Scalars["String"]>;
};

export type IntradaySeriesValue = {
    __typename?: "IntradaySeriesValue";
    series?: Maybe<Array<Maybe<DateTimeValue>>>;
    range?: Maybe<IntradayRangeValue>;
};

export type Label = {
    __typename?: "Label";
    id?: Maybe<Scalars["Int"]>;
    text?: Maybe<Scalars["String"]>;
};

export type Language = {
    __typename?: "Language";
    id?: Maybe<Scalars["Int"]>;
    labels?: Maybe<Array<Maybe<Label>>>;
};

export type Lede = Image | Video;

export type LineupCuration = {
    __typename?: "LineupCuration";
    id?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    description?: Maybe<Scalars["String"]>;
    /** Page level brand used to apply front-end themes */
    brand?: Maybe<Scalars["String"]>;
    /** The url path as defined in EditDash */
    path?: Maybe<Scalars["String"]>;
    /** Page level theme */
    theme?: Maybe<Scalars["String"]>;
    /** Page level meta image ID */
    image?: Maybe<Image>;
    modules?: Maybe<Array<Maybe<CurationModule>>>;
    lineupModule?: Maybe<CurationModule>;
    zones?: Maybe<Array<Maybe<Zone>>>;
};

export type LineupCurationLineupModuleArgs = {
    id: Scalars["String"];
    siteForModule: SiteForModule;
    state?: Maybe<PublishedState>;
};

export type LiveSchedule = {
    __typename?: "LiveSchedule";
    showInfo?: Maybe<Show>;
    episodeInfo?: Maybe<Episode>;
    episodeGuests?: Maybe<Array<Maybe<Guest>>>;
};

export enum Locale {
    En = "en",
    Ja = "ja",
}

export type Magazine = {
    __typename?: "Magazine";
    id?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    date?: Maybe<Scalars["String"]>;
    coverImage?: Maybe<Image>;
    modules?: Maybe<Array<Maybe<MagazineSection>>>;
};

export enum MagazineBrand {
    BusinessWeek = "BUSINESS_WEEK",
    Markets = "MARKETS",
    Green = "GREEN",
}

export type MagazineSection = {
    __typename?: "MagazineSection";
    title?: Maybe<Scalars["String"]>;
    items?: Maybe<Array<Maybe<Story>>>;
};

/** Magazine specific fields. */
export type MagazineStoryData = {
    __typename?: "MagazineStoryData";
    /** Strap */
    displayStrap?: Maybe<Scalars["String"]>;
    /** Print magazine headline */
    headlineShort?: Maybe<Scalars["String"]>;
    /** Magazine page number */
    pageNumber?: Maybe<Scalars["Int"]>;
    /** Magazine section */
    section?: Maybe<Scalars["String"]>;
    /** Magazine quote */
    quote?: Maybe<Scalars["String"]>;
    /** Magazine bottom line */
    postscript?: Maybe<Scalars["String"]>;
    /** Article deck */
    shortDeck?: Maybe<Scalars["String"]>;
    /** Type of magazine */
    type?: Maybe<Scalars["String"]>;
};

export type Memberships = {
    __typename?: "Memberships";
    boardMemberships?: Maybe<Array<Maybe<BoardMembership>>>;
    otherMemberships?: Maybe<Array<Maybe<OtherMembership>>>;
};

/** Site specific meta fields. */
export type Meta = {
    __typename?: "Meta";
    /** Whether it is a magazine article. Deprecated */
    magazine?: Maybe<Scalars["Boolean"]>;
    /** Whether it is a half tile story. */
    halfTile?: Maybe<Scalars["Boolean"]>;
    /** Whether to suppress the disqus comments on the story. */
    suppressComments?: Maybe<Scalars["Boolean"]>;
    /** Theme of the story such as dark or light. */
    theme?: Maybe<Scalars["String"]>;
    /** Inline assets that should be hidden on web. */
    hiddenInlineAttachments?: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Whether to exclude the story from the businessweek paywall. */
    excludeFromPaywall?: Maybe<Scalars["Boolean"]>;
    /** Whether to make the story free in Apple News businessweek channel. */
    appleNewsFree?: Maybe<Scalars["Boolean"]>;
    /** Article body background color */
    background?: Maybe<Scalars["String"]>;
    /** Whether to include a page in paywall */
    isMetered?: Maybe<Scalars["Boolean"]>;
    /** Whether to show market tickers */
    showMarketTickers?: Maybe<Scalars["Boolean"]>;
    /** Slugified id of a given newsletter */
    newsletterSlug?: Maybe<Scalars["String"]>;
    /** Override for newsletter signup tout label */
    newsletterToutLabel?: Maybe<Scalars["String"]>;
};

export type Metatext = {
    __typename?: "Metatext";
    /** HTML Text. May include html entities and nodes */
    html?: Maybe<Scalars["String"]>;
    /** Plain text. */
    text?: Maybe<Scalars["String"]>;
    /** Metatag text. For use only within the head. */
    seo?: Maybe<Scalars["String"]>;
};

export type MinScore = {
    value?: Maybe<Scalars["Float"]>;
    scoreType?: Maybe<TagScoreType>;
    tagType?: Maybe<Scalars["String"]>;
};

export type NiCodes = {
    __typename?: "NiCodes";
    id?: Maybe<Scalars["String"]>;
    score?: Maybe<Scalars["Float"]>;
    role?: Maybe<Scalars["String"]>;
};

export type OtherMembership = {
    __typename?: "OtherMembership";
    title?: Maybe<Scalars["String"]>;
    extraText?: Maybe<Scalars["String"]>;
    companyName?: Maybe<Scalars["String"]>;
    ticker?: Maybe<Scalars["String"]>;
    webTicker?: Maybe<Scalars["String"]>;
};

/** Override specific fields. */
export type Overrides = {
    __typename?: "Overrides";
    /** Indicates if thumbnail is overriden */
    thumbnail?: Maybe<Scalars["Boolean"]>;
};

export type PeopleForCompany = {
    __typename?: "PeopleForCompany";
    totalBoardMembers?: Maybe<Scalars["Int"]>;
    boardMembers?: Maybe<Array<Maybe<Person>>>;
    totalExecutives?: Maybe<Scalars["Int"]>;
    executives?: Maybe<Array<Maybe<Person>>>;
};

export enum Periodicity {
    Daily = "daily",
    Weekly = "weekly",
    Monthly = "monthly",
    Quarterly = "quarterly",
    Yearly = "yearly",
}

export type Person = {
    __typename?: "Person";
    id?: Maybe<Scalars["String"]>;
    score?: Maybe<Scalars["Float"]>;
    slug?: Maybe<Scalars["String"]>;
    /** The slug to the profile page, if the person has one. */
    profileSlug?: Maybe<Scalars["String"]>;
    roles?: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Resolved name. If byline exists, it will use byline. */
    name?: Maybe<Scalars["String"]>;
    /** Complete person name. (First + Middle + Last + "Nickname") */
    fullName?: Maybe<Scalars["String"]>;
    thumbnail?: Maybe<Image>;
    summary?: Maybe<Scalars["String"]>;
    bio?: Maybe<Scalars["String"]>;
    /** Twitter Username */
    twitter?: Maybe<Scalars["String"]>;
    /** Facebook Username */
    facebook?: Maybe<Scalars["String"]>;
    webVisibility?: Maybe<Scalars["Boolean"]>;
    stories?: Maybe<Array<Maybe<Story>>>;
    /**
     * A user with a private company may only have the companyName,
     *         but not the full company profile
     **/
    companyName?: Maybe<Scalars["String"]>;
    company?: Maybe<Company>;
    security?: Maybe<Security>;
    title?: Maybe<Scalars["String"]>;
    tenure?: Maybe<Scalars["String"]>;
    birthDay?: Maybe<Scalars["String"]>;
    birthPlace?: Maybe<Scalars["String"]>;
    awards?: Maybe<Awards>;
    careerHistory?: Maybe<Array<Maybe<Career>>>;
    education?: Maybe<Education>;
    memberships?: Maybe<Memberships>;
    /** Indicates that current author is an Editorial Board */
    editorialBoard?: Maybe<Scalars["Boolean"]>;
    /** Indicates that current author is a contributors */
    contributor?: Maybe<Scalars["Boolean"]>;
    /** Indicates that current author is a columnist */
    columnist?: Maybe<Scalars["Boolean"]>;
};

export type PersonThumbnailArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
    width?: Maybe<Scalars["Int"]>;
    height?: Maybe<Scalars["Int"]>;
    skipViewMapHeadshot?: Maybe<Scalars["Boolean"]>;
};

export type PersonBioArgs = {
    truncate?: Maybe<Scalars["Boolean"]>;
};

export type PersonTwitterArgs = {
    preferWebTwitter?: Maybe<Scalars["Boolean"]>;
};

export type PersonStoriesArgs = {
    id?: Maybe<Scalars["String"]>;
    slug?: Maybe<Scalars["String"]>;
    revision?: Maybe<Scalars["String"]>;
    primarySites?: Maybe<Array<Maybe<Brand>>>;
    brands?: Maybe<Array<Maybe<Brand>>>;
    sites?: Maybe<Array<Maybe<Site>>>;
    types?: Maybe<Array<Maybe<StoryType>>>;
    page?: Maybe<Scalars["Int"]>;
    issueId?: Maybe<Scalars["String"]>;
    sponsoredCampaignId?: Maybe<Scalars["String"]>;
    author?: Maybe<Scalars["Int"]>;
    limit?: Maybe<Scalars["Int"]>;
    site?: Maybe<Site>;
    newsletterSlug?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    sort?: Maybe<Scalars["String"]>;
    exclude?: Maybe<Array<Maybe<Scalars["String"]>>>;
    images?: Maybe<Scalars["Boolean"]>;
    pressRelease?: Maybe<Scalars["Boolean"]>;
    publishedAt?: Maybe<DateRange>;
    updatedAt?: Maybe<DateRange>;
    minScores?: Maybe<Array<Maybe<MinScore>>>;
    contentTagsV2?: Maybe<Array<Maybe<ContentTagsFilter>>>;
    followRedirect?: Maybe<Scalars["Boolean"]>;
    enforceContentCliff?: Maybe<Scalars["Boolean"]>;
};

export enum PersonRole {
    Editor = "EDITOR",
    Columnist = "COLUMNIST",
}

export type Publication = {
    __typename?: "Publication";
    extraText?: Maybe<Scalars["String"]>;
    journal?: Maybe<Scalars["String"]>;
    date?: Maybe<Scalars["String"]>;
};

export enum PublishedState {
    Published = "PUBLISHED",
    Draft = "DRAFT",
}

export type Query = {
    __typename?: "Query";
    abbaTargets?: Maybe<Scalars["String"]>;
    alerts?: Maybe<Array<Maybe<Alert>>>;
    audios?: Maybe<Array<Maybe<Audio>>>;
    charts?: Maybe<Array<Maybe<Chart>>>;
    curation?: Maybe<Curation>;
    drafts?: Maybe<Array<Maybe<Story>>>;
    exchangeMostActive?: Maybe<Array<Maybe<Security>>>;
    images?: Maybe<Array<Maybe<Image>>>;
    lineupCuration?: Maybe<LineupCuration>;
    lineupModule?: Maybe<CurationModule>;
    liveSchedules?: Maybe<Array<Maybe<LiveSchedule>>>;
    magazines?: Maybe<Array<Maybe<Magazine>>>;
    people?: Maybe<Array<Maybe<Person>>>;
    peopleForCompany?: Maybe<PeopleForCompany>;
    pressReleases?: Maybe<Array<Maybe<Story>>>;
    sectors?: Maybe<Sector>;
    securities?: Maybe<Array<Maybe<Security>>>;
    securityCategory?: Maybe<SecurityCategory>;
    sre?: Maybe<Array<Maybe<Story>>>;
    stories?: Maybe<Array<Maybe<Story>>>;
    storyFilter?: Maybe<Array<Maybe<Story>>>;
    tags?: Maybe<Array<Maybe<Tag>>>;
    targets?: Maybe<Array<Maybe<Target>>>;
    translations?: Maybe<ContextItem>;
    videos?: Maybe<Array<Maybe<Video>>>;
};

export type QueryAbbaTargetsArgs = {
    platform?: Maybe<Scalars["String"]>;
    identifier?: Maybe<Scalars["String"]>;
};

export type QueryAudiosArgs = {
    id: Array<Maybe<Scalars["String"]>>;
};

export type QueryChartsArgs = {
    id: Scalars["String"];
};

export type QueryCurationArgs = {
    site: Site;
    page?: Maybe<Scalars["String"]>;
    state?: Maybe<PublishedState>;
};

export type QueryDraftsArgs = {
    id: Scalars["String"];
    site: Site;
    type?: Maybe<ContentType>;
};

export type QueryExchangeMostActiveArgs = {
    exchange: Scalars["String"];
    tableType: ExchangeMoversTableType;
    marketCapMin?: Maybe<Scalars["String"]>;
    marketCapMax?: Maybe<Scalars["String"]>;
    timeframe?: Maybe<ExchangeMoversPeriod>;
    direction: ExchangeMoversDirection;
    limit?: Maybe<Scalars["Int"]>;
    sector?: Maybe<SectorType>;
    locale?: Maybe<Locale>;
};

export type QueryImagesArgs = {
    id: Array<Maybe<Scalars["Int"]>>;
    idType?: Maybe<IdType>;
    imageQuality?: Maybe<Scalars["Int"]>;
    width?: Maybe<Scalars["Int"]>;
    height?: Maybe<Scalars["Int"]>;
    includeImageBlobMetadata?: Maybe<Scalars["Boolean"]>;
    includePhotoCredit?: Maybe<Scalars["Boolean"]>;
};

export type QueryLineupCurationArgs = {
    site: Site;
    page?: Maybe<Scalars["String"]>;
    state?: Maybe<PublishedState>;
};

export type QueryLineupModuleArgs = {
    siteForModule: SiteForModule;
    id: Scalars["String"];
    page?: Maybe<Scalars["String"]>;
    state?: Maybe<PublishedState>;
};

export type QueryLiveSchedulesArgs = {
    channel: Scalars["String"];
    startTime?: Maybe<Scalars["String"]>;
    endTime?: Maybe<Scalars["String"]>;
};

export type QueryMagazinesArgs = {
    brand?: Maybe<Array<Maybe<MagazineBrand>>>;
    id?: Maybe<Scalars["String"]>;
    limit?: Maybe<Scalars["Int"]>;
};

export type QueryPeopleArgs = {
    id?: Maybe<Scalars["String"]>;
    slug?: Maybe<Scalars["String"]>;
    site?: Maybe<Site>;
    role?: Maybe<PersonRole>;
};

export type QueryPeopleForCompanyArgs = {
    bbid?: Maybe<Scalars["String"]>;
    peopleToExpand?: Maybe<Scalars["Int"]>;
};

export type QueryPressReleasesArgs = {
    field: TimeSearchFields;
    period: Scalars["Int"];
    units: TimeUnits;
    ticker?: Maybe<Scalars["String"]>;
};

export type QuerySecuritiesArgs = {
    id: Scalars["String"];
    type?: Maybe<TickerType>;
    locale?: Maybe<Locale>;
};

export type QuerySecurityCategoryArgs = {
    id: Scalars["String"];
};

export type QuerySreArgs = {
    sre: Scalars["String"];
    limit?: Maybe<Scalars["Int"]>;
};

export type QueryStoriesArgs = {
    id?: Maybe<Scalars["String"]>;
    slug?: Maybe<Scalars["String"]>;
    revision?: Maybe<Scalars["String"]>;
    primarySites?: Maybe<Array<Maybe<Brand>>>;
    brands?: Maybe<Array<Maybe<Brand>>>;
    sites?: Maybe<Array<Maybe<Site>>>;
    types?: Maybe<Array<Maybe<StoryType>>>;
    page?: Maybe<Scalars["Int"]>;
    issueId?: Maybe<Scalars["String"]>;
    sponsoredCampaignId?: Maybe<Scalars["String"]>;
    author?: Maybe<Scalars["Int"]>;
    limit?: Maybe<Scalars["Int"]>;
    site?: Maybe<Site>;
    newsletterSlug?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    sort?: Maybe<Scalars["String"]>;
    exclude?: Maybe<Array<Maybe<Scalars["String"]>>>;
    images?: Maybe<Scalars["Boolean"]>;
    pressRelease?: Maybe<Scalars["Boolean"]>;
    publishedAt?: Maybe<DateRange>;
    updatedAt?: Maybe<DateRange>;
    minScores?: Maybe<Array<Maybe<MinScore>>>;
    contentTagsV2?: Maybe<Array<Maybe<ContentTagsFilter>>>;
    followRedirect?: Maybe<Scalars["Boolean"]>;
    enforceContentCliff?: Maybe<Scalars["Boolean"]>;
};

export type QueryStoryFilterArgs = {
    field: TimeSearchFields;
    period: TimeUnits;
    units: Scalars["Int"];
    filter: Scalars["String"];
    sortBy?: Maybe<TimeSearchFields>;
    sortOrder?: Maybe<SortOrder>;
    limit?: Maybe<Scalars["Int"]>;
};

export type QueryTagsArgs = {
    site?: Maybe<Site>;
    id?: Maybe<Scalars["String"]>;
    slug?: Maybe<Scalars["String"]>;
    sort?: Maybe<Scalars["String"]>;
    order?: Maybe<Scalars["String"]>;
    limit?: Maybe<Scalars["Int"]>;
    type?: Maybe<Scalars["String"]>;
};

export type QueryTargetsArgs = {
    platform?: Maybe<Scalars["String"]>;
    identifier?: Maybe<Scalars["String"]>;
};

export type QueryTranslationsArgs = {
    contextId: Scalars["String"];
    languages: Scalars["String"];
    labels: Scalars["String"];
};

export type QueryVideosArgs = {
    id?: Maybe<Array<Maybe<Scalars["Int"]>>>;
    idString?: Maybe<Array<Maybe<Scalars["String"]>>>;
    idType?: Maybe<IdType>;
    includeRenditions?: Maybe<Scalars["Boolean"]>;
    includeTranscript?: Maybe<Scalars["Boolean"]>;
    transcriptLanguages?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type RatePlan = {
    __typename?: "RatePlan";
    ratePlanId?: Maybe<Scalars["String"]>;
    success?: Maybe<Scalars["Boolean"]>;
    billingPeriod?: Maybe<Scalars["String"]>;
    IncludesPrint?: Maybe<Scalars["Boolean"]>;
    charges?: Maybe<RatePlanCharge>;
};

export type RatePlanCharge = {
    __typename?: "RatePlanCharge";
    hasDiscount?: Maybe<Scalars["Boolean"]>;
    total?: Maybe<Scalars["Float"]>;
    totalWithDiscount?: Maybe<Scalars["Float"]>;
    discount?: Maybe<Array<Maybe<RatePlanDiscount>>>;
};

export type RatePlanDiscount = {
    __typename?: "RatePlanDiscount";
    discountUpToPeriods?: Maybe<Scalars["Int"]>;
};

export type Reading = {
    __typename?: "Reading";
    url?: Maybe<Scalars["String"]>;
    voice?: Maybe<Scalars["String"]>;
    durationMs?: Maybe<Scalars["Int"]>;
};

export type RelatedStories = {
    __typename?: "RelatedStories";
    news?: Maybe<Array<Maybe<Story>>>;
    opinion?: Maybe<Array<Maybe<Story>>>;
};

export type Rsf = {
    __typename?: "RSF";
    html?: Maybe<Scalars["String"]>;
    text?: Maybe<Scalars["String"]>;
    raw?: Maybe<Scalars["String"]>;
};

export type RsfHtmlArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
    allowBbgLinks?: Maybe<Scalars["Boolean"]>;
};

export type School = {
    __typename?: "School";
    school?: Maybe<Scalars["String"]>;
    degree?: Maybe<Scalars["String"]>;
};

export type Sector = {
    __typename?: "Sector";
    /** ticker associated with entity */
    security?: Maybe<Scalars["String"]>;
    name?: Maybe<Scalars["String"]>;
    id?: Maybe<Scalars["Int"]>;
    children?: Maybe<Array<Maybe<Sector>>>;
    percentChange1Day?: Maybe<Scalars["Float"]>;
    /** weight among all industries, not just in parent sector */
    weight?: Maybe<Scalars["Float"]>;
};

export enum SectorType {
    All = "ALL",
    BasicMaterials = "BASIC_MATERIALS",
    Communications = "COMMUNICATIONS",
    ConsumerCyclical = "CONSUMER_CYCLICAL",
    ConsumerNoncyclical = "CONSUMER_NONCYCLICAL",
    Diversified = "DIVERSIFIED",
    Energy = "ENERGY",
    Financial = "FINANCIAL",
    Industrial = "INDUSTRIAL",
    Technology = "TECHNOLOGY",
    Utilities = "UTILITIES",
}

export type Security = {
    __typename?: "Security";
    averageDaysToMaturity?: Maybe<Scalars["Float"]>;
    averageVolume30Day?: Maybe<Scalars["Float"]>;
    backLoadFee?: Maybe<Scalars["Float"]>;
    bbid?: Maybe<Scalars["String"]>;
    bicsIndustry?: Maybe<Scalars["String"]>;
    bicsSector?: Maybe<Scalars["String"]>;
    bicsSubIndustry?: Maybe<Scalars["String"]>;
    boardMembers?: Maybe<Array<Maybe<Person>>>;
    coFundManager?: Maybe<Scalars["String"]>;
    companyAddress?: Maybe<Scalars["String"]>;
    companyDescription?: Maybe<Scalars["String"]>;
    companyIsPrivate?: Maybe<Scalars["Boolean"]>;
    companyPhone?: Maybe<Scalars["String"]>;
    companyWebsite?: Maybe<Scalars["String"]>;
    countryIso?: Maybe<Scalars["String"]>;
    countryIssueIso?: Maybe<Scalars["String"]>;
    currentManagementFee?: Maybe<Scalars["Float"]>;
    dividend?: Maybe<Scalars["Float"]>;
    earningsAnnouncement?: Maybe<Scalars["String"]>;
    earningsPerShare?: Maybe<Scalars["Float"]>;
    estimatedEarningsPerShareCurrentYear?: Maybe<Scalars["Float"]>;
    estimatedPriceEarningsRatioCurrentYear?: Maybe<Scalars["Float"]>;
    priceEarningsToGrowthAndDividendYieldRatio?: Maybe<Scalars["Float"]>;
    estimatedPriceEarningsToGrowthRatio?: Maybe<Scalars["Float"]>;
    executives?: Maybe<Array<Maybe<Person>>>;
    expenseRatio?: Maybe<Scalars["Float"]>;
    foundedDate?: Maybe<Scalars["String"]>;
    foundedYear?: Maybe<Scalars["String"]>;
    frontLoadFee?: Maybe<Scalars["Float"]>;
    fundamentalDataCurrency?: Maybe<Scalars["String"]>;
    fundAssetClassFocus?: Maybe<Scalars["String"]>;
    fundGeographicFocus?: Maybe<Scalars["String"]>;
    fundManager?: Maybe<Scalars["String"]>;
    fundMarketingFee?: Maybe<Scalars["Float"]>;
    fundObjective?: Maybe<Scalars["String"]>;
    fundTopHoldings?: Maybe<Array<Maybe<FundHolding>>>;
    fundType?: Maybe<Scalars["String"]>;
    gicsIndustry?: Maybe<Scalars["Float"]>;
    gicsSector?: Maybe<Scalars["Float"]>;
    highPrice52Week?: Maybe<Scalars["Float"]>;
    highPrice?: Maybe<Scalars["Float"]>;
    id?: Maybe<Scalars["String"]>;
    inceptionDate?: Maybe<Scalars["DateTime"]>;
    indexDescription?: Maybe<Scalars["String"]>;
    indexSource?: Maybe<Scalars["String"]>;
    indicatedGrossDividendYield?: Maybe<Scalars["Float"]>;
    isOpen?: Maybe<Scalars["Boolean"]>;
    issuedCurrency?: Maybe<Scalars["String"]>;
    lastAnnouncementPeriod?: Maybe<Scalars["String"]>;
    lastDividendReported?: Maybe<Scalars["String"]>;
    lastUpdate?: Maybe<Scalars["DateTime"]>;
    locale?: Maybe<Scalars["String"]>;
    longName?: Maybe<Scalars["String"]>;
    lowPrice52Week?: Maybe<Scalars["Float"]>;
    lowPrice?: Maybe<Scalars["Float"]>;
    marketCap?: Maybe<Scalars["Float"]>;
    marketStatus?: Maybe<Scalars["String"]>;
    mediaSecurityType?: Maybe<Scalars["String"]>;
    mediaSecuritySubtype?: Maybe<Scalars["String"]>;
    name?: Maybe<Scalars["String"]>;
    netAssetValue?: Maybe<Scalars["Float"]>;
    netAssetValueDate?: Maybe<Scalars["DateTime"]>;
    nextEarningsAnnouncement?: Maybe<Scalars["String"]>;
    nextEarningsPeriod?: Maybe<Scalars["String"]>;
    nextEarningsPeriodEnd?: Maybe<Scalars["String"]>;
    numberOfEmployees?: Maybe<Scalars["Float"]>;
    openPrice?: Maybe<Scalars["Float"]>;
    parentTicker?: Maybe<Scalars["String"]>;
    percentChange1Day?: Maybe<Scalars["Float"]>;
    percentPremium?: Maybe<Scalars["Float"]>;
    percentPremium52WeekAverage?: Maybe<Scalars["Float"]>;
    periodicity?: Maybe<Scalars["String"]>;
    previousClosingPriceOneTradingDayAgo?: Maybe<Scalars["Float"]>;
    price?: Maybe<Scalars["Float"]>;
    priceChange1Day?: Maybe<Scalars["Float"]>;
    priceEarningsRatio?: Maybe<Scalars["Float"]>;
    priceMinDecimals?: Maybe<Scalars["Int"]>;
    priceToBookRatio?: Maybe<Scalars["Float"]>;
    priceToSalesRatio?: Maybe<Scalars["Float"]>;
    primaryExchange?: Maybe<Scalars["String"]>;
    redemptionFee?: Maybe<Scalars["Float"]>;
    score?: Maybe<Scalars["Float"]>;
    securityName?: Maybe<Scalars["String"]>;
    shareClass?: Maybe<Scalars["String"]>;
    sharesOutstanding?: Maybe<Scalars["Float"]>;
    shortName?: Maybe<Scalars["String"]>;
    subIndustry?: Maybe<Scalars["String"]>;
    timeZoneOffset?: Maybe<Scalars["Float"]>;
    totalAssets?: Maybe<Scalars["Float"]>;
    totalAssetsCurrency?: Maybe<Scalars["String"]>;
    totalAssetsDate?: Maybe<Scalars["DateTime"]>;
    totalReturn1Year?: Maybe<Scalars["Float"]>;
    totalReturn3Month?: Maybe<Scalars["Float"]>;
    totalReturn3Year?: Maybe<Scalars["Float"]>;
    totalReturn5Year?: Maybe<Scalars["Float"]>;
    totalReturnYtd?: Maybe<Scalars["Float"]>;
    tradingDayClose?: Maybe<Scalars["DateTime"]>;
    type?: Maybe<Scalars["String"]>;
    ultimateParentTicker?: Maybe<Scalars["String"]>;
    volume?: Maybe<Scalars["Float"]>;
    /**
     * This field allows for dynamic attributes. Usage:
     *   securities(id: 'SPY:US') {
     *     fundManager: variable(id: 'fundManager')
     *   }
     **/
    variable?: Maybe<Scalars["String"]>;
    /**
     * This field allows for dynamic attributes in numerical type. Usage:
     *   securities(id: 'SPY:US') {
     *     totalReturn1Year: variable(id: 'totalReturn1Year')
     *   }
     **/
    numericalVariable?: Maybe<Scalars["Float"]>;
    /**
     * This field resolves the ISO country code for the ticker to a region
     * The region names are defined by product requirements.
     **/
    region?: Maybe<Scalars["String"]>;
    /** Fetch intraday data */
    intradaySeries?: Maybe<IntradaySeriesValue>;
    /** Fetch history data */
    historySeries?: Maybe<Array<Maybe<DateTimeValue>>>;
    pressReleases?: Maybe<Array<Maybe<Story>>>;
    indexMovers?: Maybe<Array<Maybe<Security>>>;
    indexMembers?: Maybe<Array<Maybe<Security>>>;
};

export type SecurityVariableArgs = {
    id: Scalars["String"];
};

export type SecurityNumericalVariableArgs = {
    id: Scalars["String"];
};

export type SecurityIntradaySeriesArgs = {
    field: Scalars["String"];
    days?: Maybe<Scalars["Int"]>;
    interval?: Maybe<Scalars["Int"]>;
};

export type SecurityHistorySeriesArgs = {
    field: Scalars["String"];
    startDate: Scalars["String"];
    endDate: Scalars["String"];
    periodicity?: Maybe<Periodicity>;
    currency?: Maybe<Scalars["String"]>;
};

export type SecurityPressReleasesArgs = {
    field: TimeSearchFields;
    period: Scalars["Int"];
    units: TimeUnits;
    ticker?: Maybe<Scalars["String"]>;
};

export type SecurityIndexMoversArgs = {
    criteria?: Maybe<Criteria>;
};

export type SecurityIndexMembersArgs = {
    size?: Maybe<Scalars["Int"]>;
};

export type SecurityCategory = {
    __typename?: "SecurityCategory";
    id?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    terminalSecurityType?: Maybe<Scalars["String"]>;
    mediaSecurityType?: Maybe<Scalars["String"]>;
    mediaSecuritySubtype?: Maybe<Scalars["String"]>;
};

export type Show = {
    __typename?: "Show";
    showMrcId?: Maybe<Scalars["String"]>;
    showStatusId?: Maybe<Scalars["Int"]>;
    showSourceId?: Maybe<Scalars["Int"]>;
    showTitle?: Maybe<Scalars["String"]>;
    showDescription?: Maybe<Scalars["String"]>;
    showTimeSummary?: Maybe<Array<Maybe<Scalars["String"]>>>;
    showNiCode?: Maybe<Array<Maybe<Scalars["String"]>>>;
    showKeywords?: Maybe<Array<Maybe<Scalars["String"]>>>;
    hostBioIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
    hosts?: Maybe<Array<Maybe<Scalars["String"]>>>;
    thumbnail?: Maybe<Image>;
};

export type ShowInfo = {
    __typename?: "ShowInfo";
    /** Show Id */
    id?: Maybe<Scalars["String"]>;
    /** Show display name */
    name?: Maybe<Scalars["String"]>;
};

export enum Site {
    View = "VIEW",
    Gadfly = "GADFLY",
    Quicktake = "QUICKTAKE",
    Business = "BUSINESS",
    Politics = "POLITICS",
    Cybersecurity = "CYBERSECURITY",
    ClimateChanged = "CLIMATE_CHANGED",
    Businessweek = "BUSINESSWEEK",
    SpecialIssue = "SPECIAL_ISSUE",
    NewEconomyForum = "NEW_ECONOMY_FORUM",
    Markets = "MARKETS",
    Mobile = "MOBILE",
    Opinion = "OPINION",
    BusinessWeekApp = "BUSINESS_WEEK_APP",
    Technology = "TECHNOLOGY",
    Pursuits = "PURSUITS",
    Tv = "TV",
    AppleNews = "APPLE_NEWS",
    Cojp = "COJP",
    Sponsored = "SPONSORED",
    Feeds = "FEEDS",
    Socialflow = "SOCIALFLOW",
    Hyperdrive = "HYPERDRIVE",
    Prognosis = "PROGNOSIS",
    Green = "GREEN",
    Screentime = "SCREENTIME",
    Citylab = "CITYLAB",
}

export enum SiteForModule {
    View = "VIEW",
    Gadfly = "GADFLY",
    Quicktake = "QUICKTAKE",
    Business = "BUSINESS",
    Politics = "POLITICS",
    Businessweek = "BUSINESSWEEK",
    Markets = "MARKETS",
    Mobile = "MOBILE",
    BusinessWeekApp = "BUSINESS_WEEK_APP",
    Technology = "TECHNOLOGY",
    Pursuits = "PURSUITS",
    Tv = "TV",
    AppleNews = "APPLE_NEWS",
    Cojp = "COJP",
    Feeds = "FEEDS",
    Socialflow = "SOCIALFLOW",
    Green = "GREEN",
    Citylab = "CITYLAB",
}

export type Social = {
    __typename?: "Social";
    /** Title for Social Card. .i.e. og:title */
    title?: Maybe<Scalars["String"]>;
    /** Body for Social Card. i.e. og:description */
    body?: Maybe<Scalars["String"]>;
    /** Thumbnail for Social Card. i.e. og:image */
    image?: Maybe<Image>;
    /** Text to be displayed in social post. i.e. facebook:status */
    shareText?: Maybe<Scalars["String"]>;
};

export type SocialImageArgs = {
    height?: Maybe<Scalars["Int"]>;
    width?: Maybe<Scalars["Int"]>;
};

export enum SortOrder {
    Asc = "ASC",
    Desc = "DESC",
}

/** Default Content Type */
export type Story = {
    __typename?: "Story";
    id?: Maybe<Scalars["String"]>;
    revision?: Maybe<Scalars["String"]>;
    audios?: Maybe<Array<Maybe<Audio>>>;
    images?: Maybe<Array<Maybe<Image>>>;
    videos?: Maybe<Array<Maybe<Video>>>;
    iframes?: Maybe<Array<Maybe<Iframe>>>;
    abstract?: Maybe<Array<Maybe<Scalars["String"]>>>;
    facebook?: Maybe<Social>;
    twitter?: Maybe<Social>;
    headline?: Maybe<Metatext>;
    summary?: Maybe<Metatext>;
    autoGeneratedSummary?: Maybe<Metatext>;
    autoSummaries?: Maybe<Array<Maybe<AutoSummary>>>;
    subheadline?: Maybe<Scalars["String"]>;
    byline?: Maybe<Scalars["String"]>;
    header?: Maybe<Rsf>;
    body?: Maybe<Rsf>;
    timeline?: Maybe<Rsf>;
    footer?: Maybe<Rsf>;
    disclaimer?: Maybe<Rsf>;
    trashline?: Maybe<Rsf>;
    corrected?: Maybe<Scalars["Boolean"]>;
    adIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
    adTargeting?: Maybe<AdTargeting>;
    attributor?: Maybe<Scalars["String"]>;
    campaign?: Maybe<Campaign>;
    wire?: Maybe<Wire>;
    widget?: Maybe<Widget>;
    lede?: Maybe<Lede>;
    ledeKind?: Maybe<Scalars["String"]>;
    hedAndDekPosition?: Maybe<Scalars["String"]>;
    thumbnail?: Maybe<Image>;
    mobileLede?: Maybe<Image>;
    publishedAt?: Maybe<Scalars["DateTime"]>;
    updatedAt?: Maybe<Scalars["DateTime"]>;
    minorUpdatedAt?: Maybe<Scalars["DateTime"]>;
    checksum?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
    shortUrl?: Maybe<Scalars["String"]>;
    slug?: Maybe<Scalars["String"]>;
    related?: Maybe<RelatedStories>;
    label?: Maybe<Scalars["String"]>;
    topic?: Maybe<Tag>;
    credits?: Maybe<Array<Maybe<Person>>>;
    /**
     * If the story byline is "Bloomberg News", returns the credits with role
     *       by, reporter, contributor, or assist.  Any other byline only returns assist role.
     **/
    assistance?: Maybe<Array<Maybe<Person>>>;
    categories?: Maybe<Array<Maybe<Scalars["String"]>>>;
    disableAds?: Maybe<Scalars["Boolean"]>;
    issueId?: Maybe<Scalars["String"]>;
    magazine?: Maybe<MagazineStoryData>;
    magazineIssue?: Maybe<Magazine>;
    people?: Maybe<Array<Maybe<Person>>>;
    tags?: Maybe<Array<Maybe<Tag>>>;
    indexes?: Maybe<Array<Maybe<Security>>>;
    tickers?: Maybe<Array<Maybe<Security>>>;
    nicodes?: Maybe<Array<Maybe<NiCodes>>>;
    terminalTickers?: Maybe<Array<Maybe<Tag>>>;
    charts?: Maybe<Array<Maybe<Chart>>>;
    /** primary site the story is associated with (maps to primary brand) */
    site?: Maybe<Scalars["String"]>;
    /** all sites the story is associated with (map to brands and franchises) */
    sites?: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** franchise the story is associated with */
    franchise?: Maybe<Scalars["String"]>;
    /** primary brand the story is associated with (mapped from primary site) */
    brand?: Maybe<Scalars["String"]>;
    /** non-primary brands the story is associated with (derived from sites) */
    secondaryBrands?: Maybe<Array<Maybe<Scalars["String"]>>>;
    type?: Maybe<Scalars["String"]>;
    authoredRegion?: Maybe<Scalars["String"]>;
    webOriginal?: Maybe<Scalars["Boolean"]>;
    contentTags?: Maybe<Array<Maybe<ContentTag>>>;
    readings?: Maybe<Array<Maybe<Reading>>>;
    featureVersion?: Maybe<Scalars["Int"]>;
    show?: Maybe<ShowInfo>;
    curatedAt?: Maybe<Scalars["DateTime"]>;
    template?: Maybe<Scalars["String"]>;
    reaction?: Maybe<Scalars["String"]>;
    meta?: Maybe<Meta>;
    /** Indicator of fields overriden by Editdash */
    overrides?: Maybe<Overrides>;
    /** Indicate whether or not this Story needs to be behind the content cliff */
    archived?: Maybe<Scalars["Boolean"]>;
    /**
     * Indicates whether the Story has a new slug that is different than the one used
     * in the query. This is used to determine whether a frontend app should redirect
     * a client. The query must be slug based and explicitly set the "followRedirect"
     * argument to false.
     **/
    moved?: Maybe<Scalars["Boolean"]>;
    language?: Maybe<Scalars["String"]>;
    /** Returns story word count */
    wordCount?: Maybe<Scalars["Int"]>;
    /** Indicates whether the Story is premium (subscription only) content. */
    premium?: Maybe<Scalars["Boolean"]>;
    /**
     * The resource type of the story used across different application in media,
     * e.g., personalization,tracking,tagger,notification
     **/
    resourceType?: Maybe<Scalars["String"]>;
    /** story threads that contain this story */
    storythreads?: Maybe<Array<Maybe<Story>>>;
};

/** Default Content Type */
export type StoryImagesArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
    includeImageBlobMetadata?: Maybe<Scalars["Boolean"]>;
    includePhotoCredit?: Maybe<Scalars["Boolean"]>;
    themedOnly?: Maybe<Scalars["Boolean"]>;
};

/** Default Content Type */
export type StoryVideosArgs = {
    includeTranscript?: Maybe<Scalars["Boolean"]>;
    includeRenditions?: Maybe<Scalars["Boolean"]>;
    transcriptLanguages?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Default Content Type */
export type StoryFacebookArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryBodyArgs = {
    setIframes?: Maybe<Scalars["Boolean"]>;
};

/** Default Content Type */
export type StoryLedeArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryThumbnailArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryMobileLedeArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryPeopleArgs = {
    sort?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    limit?: Maybe<Scalars["Int"]>;
    score?: Maybe<FloatRange>;
};

/** Default Content Type */
export type StoryTagsArgs = {
    sort?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    limit?: Maybe<Scalars["Int"]>;
    score?: Maybe<FloatRange>;
};

/** Default Content Type */
export type StoryIndexesArgs = {
    sort?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    limit?: Maybe<Scalars["Int"]>;
    score?: Maybe<FloatRange>;
};

/** Default Content Type */
export type StoryTickersArgs = {
    sort?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    limit?: Maybe<Scalars["Int"]>;
    score?: Maybe<FloatRange>;
};

/** Default Content Type */
export type StoryNicodesArgs = {
    sort?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    limit?: Maybe<Scalars["Int"]>;
    score?: Maybe<FloatRange>;
};

/** Default Content Type */
export type StoryContentTagsArgs = {
    limit?: Maybe<Scalars["Int"]>;
    types?: Maybe<Array<Maybe<Scalars["String"]>>>;
    minScores?: Maybe<Array<Maybe<MinScore>>>;
    sort?: Maybe<Scalars["Boolean"]>;
    sortV2?: Maybe<ContentTagsSort>;
};

export enum StoryType {
    Article = "ARTICLE",
    Breaking = "BREAKING",
    Data = "DATA",
    Slideshow = "SLIDESHOW",
    ImpactScorecard = "IMPACT_SCORECARD",
    Interactive = "INTERACTIVE",
    Feature = "FEATURE",
    Quicktake = "QUICKTAKE",
    Video = "VIDEO",
    Letter = "LETTER",
    NewsletterCampaign = "NEWSLETTER_CAMPAIGN",
}

export type Tag = {
    __typename?: "Tag";
    id?: Maybe<Scalars["String"]>;
    score?: Maybe<Scalars["Float"]>;
    name?: Maybe<Scalars["String"]>;
    slug?: Maybe<Scalars["String"]>;
    kind?: Maybe<Scalars["String"]>;
    stories?: Maybe<Array<Maybe<Story>>>;
};

export type TagStoriesArgs = {
    id?: Maybe<Scalars["String"]>;
    slug?: Maybe<Scalars["String"]>;
    revision?: Maybe<Scalars["String"]>;
    primarySites?: Maybe<Array<Maybe<Brand>>>;
    brands?: Maybe<Array<Maybe<Brand>>>;
    sites?: Maybe<Array<Maybe<Site>>>;
    types?: Maybe<Array<Maybe<StoryType>>>;
    page?: Maybe<Scalars["Int"]>;
    issueId?: Maybe<Scalars["String"]>;
    sponsoredCampaignId?: Maybe<Scalars["String"]>;
    author?: Maybe<Scalars["Int"]>;
    limit?: Maybe<Scalars["Int"]>;
    site?: Maybe<Site>;
    newsletterSlug?: Maybe<Scalars["String"]>;
    order?: Maybe<SortOrder>;
    sort?: Maybe<Scalars["String"]>;
    exclude?: Maybe<Array<Maybe<Scalars["String"]>>>;
    images?: Maybe<Scalars["Boolean"]>;
    pressRelease?: Maybe<Scalars["Boolean"]>;
    publishedAt?: Maybe<DateRange>;
    updatedAt?: Maybe<DateRange>;
    minScores?: Maybe<Array<Maybe<MinScore>>>;
    contentTagsV2?: Maybe<Array<Maybe<ContentTagsFilter>>>;
    followRedirect?: Maybe<Scalars["Boolean"]>;
    enforceContentCliff?: Maybe<Scalars["Boolean"]>;
};

export enum TagScoreType {
    Direct = "DIRECT",
    Derived = "DERIVED",
}

/** A/B Targeting and Testing Dashboard target type */
export type Target = {
    __typename?: "target";
    targetId?: Maybe<Scalars["String"]>;
    priority?: Maybe<Scalars["Int"]>;
    condition?: Maybe<Scalars["String"]>;
    config?: Maybe<Scalars["String"]>;
    experiments?: Maybe<Array<Maybe<AbbaTargetExperiment>>>;
};

export type Theme = {
    __typename?: "Theme";
    id?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
};

export enum TickerType {
    Cef = "CEF",
    Com = "COM",
    Cor = "COR",
    Cur = "CUR",
    Eqt = "EQT",
    Etp = "ETP",
    Gov = "GOV",
    Ind = "IND",
    Indc = "INDC",
    Indf = "INDF",
    Indn = "INDN",
    Inds = "INDS",
    Mmf = "MMF",
    Mtg = "MTG",
    Mun = "MUN",
    Oef = "OEF",
    Oefh = "OEFH",
}

export enum TimeSearchFields {
    StoryUpdatedAt = "storyUpdatedAt",
    StoryPublishedAt = "storyPublishedAt",
    GroupPublishedAt = "groupPublishedAt",
}

export enum TimeUnits {
    Minutes = "minutes",
    Hours = "hours",
    Days = "days",
    Weeks = "weeks",
    Months = "months",
    Years = "years",
}

export type Tracking = {
    __typename?: "Tracking";
    id?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
};

export type Video = {
    __typename?: "Video";
    id?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    transcript?: Maybe<Scalars["String"]>;
    duration?: Maybe<Scalars["Int"]>;
    showName?: Maybe<Scalars["String"]>;
    createdUnixUTC?: Maybe<Scalars["DateTime"]>;
    title?: Maybe<Scalars["String"]>;
    description?: Maybe<Scalars["String"]>;
    caption?: Maybe<Scalars["String"]>;
    credit?: Maybe<Scalars["String"]>;
    cedexisAppID?: Maybe<Scalars["String"]>;
    ni?: Maybe<Scalars["String"]>;
    avmmIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
    prerollAdUnit?: Maybe<Scalars["String"]>;
    compressedIds?: Maybe<Scalars["String"]>;
    thumbnail?: Maybe<Image>;
    story?: Maybe<Story>;
    streams?: Maybe<Array<Maybe<VideoStream>>>;
    contentLocation?: Maybe<Scalars["String"]>;
    renditions?: Maybe<Array<Maybe<Video>>>;
    /** Only applicable to lede videos. */
    autoplay?: Maybe<Scalars["Boolean"]>;
    mobile?: Maybe<AssetMedia>;
    desktop?: Maybe<AssetMedia>;
    renditionType?: Maybe<Scalars["String"]>;
};

export type VideoThumbnailArgs = {
    imageQuality?: Maybe<Scalars["Int"]>;
};

export type VideoStream = {
    __typename?: "VideoStream";
    url?: Maybe<Scalars["String"]>;
    percent?: Maybe<Scalars["Int"]>;
    height?: Maybe<Scalars["Int"]>;
    width?: Maybe<Scalars["Int"]>;
    type?: Maybe<Scalars["String"]>;
    size?: Maybe<Scalars["Int"]>;
    format?: Maybe<Scalars["String"]>;
    codec?: Maybe<Codec>;
    bitrate?: Maybe<Bitrate>;
};

export type Widget = {
    __typename?: "Widget";
    id?: Maybe<Scalars["Int"]>;
    url?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    type?: Maybe<Scalars["String"]>;
    html?: Maybe<Scalars["String"]>;
};

export type Wire = {
    __typename?: "Wire";
    mnemonic?: Maybe<Scalars["String"]>;
    class?: Maybe<Scalars["Int"]>;
    id?: Maybe<Scalars["Int"]>;
};

export type Zone = {
    __typename?: "Zone";
    name?: Maybe<Scalars["String"]>;
    kind?: Maybe<Scalars["String"]>;
    columns?: Maybe<Array<Maybe<Column>>>;
};
